<template>
  <div>
    <Head title="Edit Entry" />
    <form @submit.prevent="update">
      <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
        <h1 class="w-full mt-6 pb-10 text-xl md:text-3xl font-bold flex flex-col md:flex-row items-start md:items-center">
            <Link class="text-indigo-400 hover:text-indigo-600 mb-2 md:mb-0" href="/reem">
              <small>Back</small>
            </Link>
            <span class="text-indigo-400 font-medium md:mx-2">|</span>
            <span>{{ managers.name }}</span>
            <span v-if="!isDraft" class="text-sm md:text-base mt-2 md:mt-0 md:ml-2">
              <small>({{ status.process }} at {{ formatDate(status.created_at) }})</small>
            </span>
          </h1>

            <qrcode-vue style="display:none;" ref="qrcode" :value="qrcode"></qrcode-vue>        
            <!--
            <a class="btn-indigo cursor-pointer flex items-center px-6 py-4 mr-6 focus:text-indigo-500" @click="generateForm('REEM')">
              <icon name="adobe" class="mr-2 w-4 h-4 fill-white" />
              Cetak Borang
            </a>
            -->
            <a v-if="owner || status.process=='approved'" class="btn-indigo cursor-pointer flex items-center px-6 py-4 mr-6 focus:text-indigo-500" @click="generateCertificate('REEM-CERT')">
              <icon name="adobe" class="mr-2 w-4 h-4 fill-white" />
              Generate Certificate
            </a>
            <span v-if="!owner">
            <loading-button v-if="isDraft" :loading="form.submitting" class="btn-action px-6 py-4 mr-6" @click.prevent="submitForm()">
              📩&nbsp;&nbsp;Submit Application
            </loading-button>
            </span>
            <span v-if="!owner">
            <loading-button v-if="isDraft" :loading="form.saving" class="btn-indigo px-6 py-4 mr-6" @click.prevent="update()">
              💾&nbsp;&nbsp;Save Record
            </loading-button>
            </span>
            <a class="btn-indigo cursor-pointer flex items-center px-6 py-4 mr-6 focus:text-indigo-500" @click="loadFeedbacks">
              💬&nbsp;&nbsp;Comments ({{feedbacks.total}})
            </a>
            <a v-if="owner" class="btn-indigo cursor-pointer flex items-center px-6 py-4 mr-6 focus:text-indigo-500" @click="processSubmission">
              <icon name="process" class="mr-2 w-4 h-4 fill-white" />Process
            </a>
        </div>       
      
        <div class="bg-white rounded-md shadow overflow-hidden pt-6">     
          <form-wizard step-size="xs" @on-complete="onComplete" ref="wizard">
          
          <tab-content title="Bahagian A : Maklumat Pemohon">
            
            <div class="flex items-center justify-between mt-6">
              <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
                👤 <span class="text-indigo-600">Maklumat Pemohon</span>
              </h1>
            </div>


              <div class="relative block p-4">
                <AvatarInput v-model="form.photo" class="w-48 h-48 rounded-full ml-auto mr-auto" :default-src="managers.photo"/>
              </div>
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <select-input :disabled="!isDraft" v-model="form.category" :error="form.errors.category" class="pb-8 pr-6 w-full lg:w-1/2" label="Jenis Permohonan ">
                  <option :value="null" />
                  <option value="temuduga">Temuduga Professional</option>
                  <option value="kursus">Enakmen Bekalan Elektrik 2024 & EMEER 2024</option>
              </select-input>   
              <text-input :disabled="!isDraft" required v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full" label="*Nama Pengadu " />
              <text-input :disabled="!isDraft" v-model="form.ic_no" :error="form.errors.ic_no" class="pb-8 pr-6 w-full lg:w-1/2" label="No. MyKad " />
              <div v-if="ic_copy_upload" class="flex items-center w-full lg:w-1/2">
                  <span style="width: 100%;" class="w-100 text-3xl font-bold">
                    <a class="text-xl cursor-pointer items-center flex py-4 pr-2 lg:w-1/2 focus:text-indigo-500" target="_blank" :href="managers.ic_copy.attachment">
                    <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                      <small>View Uploaded MyKad</small>
                    </a> 
                  </span>  
                  <a v-if="isDraft" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="remove(managers.ic_copy.details)">
                    <icon name="trash" class="w-4 h-4 fill-indigo-400" />
                  </a>
              </div>
              <file-input :hidden="!isDraft" @change="fileChanged('ic_copy')" v-if="!ic_copy_upload" v-model="form.ic_copy" :error="form.errors.ic_copy" class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="application/pdf" label="*📎 Salinan Kad Pengenalan Pemohon - Depan & Belakang (pdf)" /> 
              <text-input :disabled="!isDraft" v-model="form.id_no" :error="form.errors.id_no" class="pb-8 pr-6 w-full lg:w-1/2" label="No Pengenalan Lain (cth. Passport) " />
              <select-input :disabled="!isDraft" v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full lg:w-1/2" label="Jenis Pengurus Tenaga ">
                  <option :value="null" />
                  <option value="terhad">Terhad</option>
                  <option value="terbuka">Terbuka</option>
              </select-input> 
              <Datepicker
                :disabled="!isDraft" 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.birthday"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Lahir"></Datepicker>
              <select-input :disabled="!isDraft" v-model="form.gender" :error="form.errors.gender" class="pb-8 pr-6 w-full lg:w-1/2" label="Jantina ">
                  <option :value="null" />
                  <option value="M">Lelaki</option>
                  <option value="F">Perempuan</option>
              </select-input> 
              <text-input :disabled="!isDraft" v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full" label="Alamat " />
              <text-input :disabled="!isDraft" v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full" label="Bandar " />
              <text-input :disabled="!isDraft" v-model="form.postal_code" :error="form.errors.postal_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Poskod " />
              <!-- SELECT OPTION FOR NEGERI -->  <!-- SAME ABOVE-->
              <select-input :disabled="!isDraft" v-model="form.region" :error="form.errors.region" class="pb-8 pr-6 w-full lg:w-1/2" label="Negeri ">
                  <option :value="null">[Pilih Negeri]</option>
                  <option value="johor">Johor</option>
                  <option value="kedah">Kedah</option>
                  <option value="kelantan">Kelantan</option>
                  <option value="kuala_lumpur">Kuala Lumpur</option>
                  <option value="labuan">Labuan</option>
                  <option value="malacca">Malacca</option>
                  <option value="negeri_sembilan">Negeri Sembilan</option>
                  <option value="pahang">Pahang</option>
                  <option value="penang">Penang</option>
                  <option value="perak">Perak</option>
                  <option value="perlis">Perlis</option>
                  <option value="putrajaya">Putrajaya</option>
                  <option value="sabah">Sabah</option>
                  <option value="sarawak">Sarawak</option>
                  <option value="selangor">Selangor</option>
                  <option value="terengganu">Terengganu</option>
              </select-input> 


              <text-input :disabled="!isDraft" v-model="form.mail_address" :error="form.errors.mail_address" class="pb-8 pr-6 w-full" label="Alamat Surat Menyurat " />
              <text-input :disabled="!isDraft" v-model="form.mail_city" :error="form.errors.mail_city" class="pb-8 pr-6 w-full" label="Bandar " />
              <text-input :disabled="!isDraft" v-model="form.mail_poscode" :error="form.errors.mail_poscode" class="pb-8 pr-6 w-full lg:w-1/2" label="Poskod " />
              <text-input :disabled="!isDraft" v-model="form.mail_state" :error="form.errors.mail_state" class="pb-8 pr-6 w-full lg:w-1/2" label="Negeri " />
  
              <text-input :disabled="!isDraft" v-model="form.phone_no" :error="form.errors.premise_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Telefon " />
              <text-input :disabled="!isDraft" v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Telefon (HP) " />
              <text-input :disabled="!isDraft" v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Alamat Email " />
              

            </div>
        </tab-content>
        <tab-content title="Bahagian B : Maklumat Majikan Dan Pekerjaan">

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              🏢 <span class="text-indigo-600">Maklumat Majikan Dan Pekerjaan</span>
            </h1>
          </div>


          <div class="flex flex-wrap -mb-8 -mr-6 p-8">           

              <text-input :disabled="!isDraft" required v-model="form.company_name" :error="form.errors.company_name" class="pb-8 pr-6 w-full" label="*Nama Majikan " />
              <text-input :disabled="!isDraft" v-model="form.company_address" :error="form.errors.company_address" class="pb-8 pr-6 w-full" label="Alamat Majikan " />
              
              <text-input :disabled="!isDraft" v-model="form.company_city" :error="form.errors.company_city" class="pb-8 pr-6 w-full" label="Bandar " />
              <text-input :disabled="!isDraft" v-model="form.company_poscode" :error="form.errors.company_poscode" class="pb-8 pr-6 w-full lg:w-1/2" label="Poskod " />
              <text-input :disabled="!isDraft" v-model="form.company_state" :error="form.errors.company_state" class="pb-8 pr-6 w-full lg:w-1/2" label="Negeri " />
  

              <text-input :disabled="!isDraft" v-model="form.company_phone" :error="form.errors.company_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Telefon " />
              <text-input :disabled="!isDraft" v-model="form.company_fax" :error="form.errors.company_fax" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Fax " />
              
              <text-input :disabled="!isDraft" v-model="form.website" :error="form.errors.website" class="pb-8 pr-6 w-full" label="Alamat Laman Web " />
              <text-input :disabled="!isDraft" v-model="form.position" :error="form.errors.position" class="pb-8 pr-6 w-full lg:w-1/2" label="Jawatan Terkini " />
                  
              </div>

        </tab-content>
        <tab-content title="Bahagian C : Kelayakan Pemohon">

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              🏢 <span class="text-indigo-600">Kelayakan Professional</span>
            </h1>
          </div>
          
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">           
            <text-input :disabled="!isDraft" v-model="form.my_engineering_register" :error="form.errors.my_engineering_register" class="pb-8 pr-6 w-full" label="No. Pendaftaran Jurutera Profesional " />
            <text-input :disabled="!isDraft" v-model="form.my_engineering_reff" :error="form.errors.my_engineering_reff" class="pb-8 pr-6 w-full" label="No. resit pembaharuan pendaftaran dengan Lembaga Jurutera Malaysia yang terkini (tahun semasa) " />
          </div>

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              📃 <span class="text-indigo-600">Perakuan Kekompetenan oleh ECoS / ST sedia ada</span>
            </h1>
            <a v-if="isDraft" class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formCompetentPerson">
              <icon name="upload" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
            </a> 
          </div>
          
          <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="pb-4 pt-6 px-6 text-center">Perakuan Kekompetenan</th>
                <th class="pb-4 pt-6 px-6 text-center">Sekatan</th>
                <th class="pb-4 pt-6 px-6 text-center">No. Perakuan</th>
                <th class="pb-4 pt-6 px-6 text-center">Action</th>
              </tr>
              <tr v-for="competent in competents" :key="competent.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t py-2 pb-2 pl-6">
                    <span class="flex">{{ competent.name }}</span>
                    <icon v-if="competent.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </td>
                <td class="border-t">
                  <span>{{ competent.competent_restriction }}</span>     
                </td>
                <td class="border-t text-center">
                  <span>{{ competent.cert_no }}</span>
                </td>
                <td class="border-t text-center">
                  <center>
                  <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadCompetent(competent)">
                    <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                    Edit 
                  </a>                
                  </center>                      
                </td>
              </tr>
              <tr v-if="competents.length === 0">
                <td class="px-6 py-4 border-t" colspan="4">
                  <span class="flex justify-center py-2">
                    <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                    Tiada orang kompetent.&nbsp;&nbsp;
                    <a v-if="isDraft" class="cursor-pointer text-indigo-500" @click="formCompetentPerson()">
                      <strong>Tambah rekod</strong>
                    </a>
                  </span>               
                </td>
              </tr>
            </table>
          </div>

          <div class="flex items-center justify-between mt-6">
                <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
                  📜 <span class="text-indigo-600">Kelayakan Akademik</span>
                </h1>
                <a v-if="isDraft" class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formAcedemics">
                  <icon name="upload" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
                </a> 
              </div>
              
              <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
                <table class="w-full whitespace-nowrap">
                  <tr class="text-left font-bold">
                    <th class="pb-4 pt-6 px-6 text-center">Nama Ijazah/Kelulusan yang setaraf</th>  
                    <th class="pb-4 pt-6 px-6 text-center">Nama Institusi/Universiti</th>
                    <th class="pb-4 pt-6 px-6 text-center">Tarikh Lulus</th>
                    <th class="pb-4 pt-6 px-6 text-center">Action</th>
                  </tr>
                  <tr v-for="academic in academics" :key="academic.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                    <td class="border-t py-2 pb-2 pl-6">
                      <span class="flex">{{ academic.name }}</span>
                      <icon v-if="academic.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                    </td>
                    <td class="border-t text-center">
                      <span>{{ academic.course }}</span>   
                    </td>
                    <td class="border-t text-center">
                      <span>{{ academic.cert_date }}</span>  
                    </td>
                    <td class="border-t text-center">
                      <center>
                      <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadAcademic(academic)">
                        <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                        Edit 
                      </a>                
                      </center>                      
                    </td>
                    <!-- <td v-if="form.owner" class="border-t text-center">
                      ..
                    </td> -->
                  </tr>
                  <tr v-if="academics.length === 0">
                    <td class="px-6 py-4 border-t" colspan="4">
                      <span class="flex justify-center py-2">
                        <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                        Tiada rekod akademik.&nbsp;&nbsp;
                        <a v-if="isDraft" class="cursor-pointer text-indigo-500" @click="formAcedemics()">
                          <strong>Tambah rekod</strong>
                        </a>
                      </span>               
                    </td>
                  </tr>
                </table>
              </div>


        </tab-content>
        <tab-content title="Bahagian D :  Rekod Pengalaman Kerja Pemohon">

          <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
              🗃 <span class="text-indigo-600">Rekod Pengalaman Kerja</span>
            </h1>
            <a v-if="isDraft" class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formExperiences">
              <icon name="upload" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
            </a> 
          </div>

          <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
            <table class="w-full whitespace-nowrap">
              <tr class="text-left font-bold">
                <th class="pb-4 pt-6 px-6 text-center">Nama Majikan</th>
                <th class="pb-4 pt-6 px-6 text-center">Alamat Majikan</th>
                <th class="pb-4 pt-6 px-6 text-center">Jawatan</th>
                <th class="pb-4 pt-6 px-6 text-center">Bidang Tugas</th>
                <th class="pb-4 pt-6 px-6 text-center">Tarikh Mula</th>
                <th class="pb-4 pt-6 px-6 text-center">Tarikh Tamat</th>
                <th class="pb-4 pt-6 px-6 text-center">Action</th>
              </tr>
              <tr v-for="experience in experiences" :key="experience.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t pl-4">
                  <span class="flex">{{ experience.name }}</span>
                  <icon v-if="experience.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
                </td>
                <td class="border-t py-2 pb-2 pl-6">
                  <span class="flex">{{ experience.address }}</span>  
                </td>
                <td class="border-t text-center">
                  <center>
                    <span>{{ experience.position }}</span>
                  </center> 
                </td>
                <td class="border-t text-center">
                  <center>
                    <span>{{ experience.jobs }}</span>
                  </center>   
                </td>
                <td class="border-t text-center">
                  <center>
                    <span>{{ experience.start_date }}</span>
                  </center>  
                </td>
                <td class="border-t text-center">
                  <center>
                    <span>{{ experience.end_date }}</span>
                  </center>
                </td>
                <td class="border-t text-center">
                  <center>
                  <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadExperience(experience)">
                    <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                    Edit 
                  </a>                
                  </center>                      
                </td>
              </tr>
              <tr v-if="experiences.length === 0">
                <td class="px-6 py-4 border-t" colspan="7">
                  <span class="flex justify-center py-2">
                    <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                    Tiada rekod pengalaman kerja.&nbsp;&nbsp;
                    <a v-if="isDraft" class="cursor-pointer text-indigo-500" @click="formExperiences()">
                      <strong>Tambah rekod</strong>
                    </a>
                  </span>               
                </td>
              </tr>
            </table>
          </div>           

          
        </tab-content>

        <tab-content title="Bahagian E :  Pengalaman Kerja Pemohon Dalam Pengurusan Tenaga Elektrik Dengan Cekap">

        <div class="flex items-center justify-between mt-6">
          <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
            🗃 <span class="text-indigo-600">Pengalaman Kerja Pemohon Dalam Pengurusan Tenaga Elektrik Dengan Cekap</span>
          </h1>
        </div>

        <div class="flex flex-wrap mb-8 mr-6 p-8">

        <p class="text-lg">(i) Tugas-tugas Berkenaan Pengurusan Tenaga Elektrik dengan Cekap Yang Pernah Dilaksanakan</p>
        <p class="text-lg pt-4">Sila terangkan dengan terperinci tentang tugas-tugas pengurusan tenaga elektrik dengan cekap yang dilaksanakan di 
          <a href="/Lampiran-A.pdf" target="_blank">Lampiran A</a>
        </p>

        <p class="text-lg pt-12">(ii) Laporan Projek/Tugas Berkenaan Pengurusan Tenaga Elektrik dengan Cekap</p>
        <p class="text-lg pt-4">Sila sediakan dan sertakan laporan lengkap mengenai projek/tugas yang ada terlibat berkenaan pengurusan tenaga elektrik dengan cekap seperti panduan berikut:-</p>

        <ol class="ml-4">
          <li class="pt-2 pb-2">a) Nama dan penerangan projek;</li>
          <li class="pb-2">b) Senarai nama mereka yang terlibat,jawatan dan peranan masing-masing;</li>
          <li class="pb-2">c) Penerangan kajian awal (feasibility study)/audit tenaga yang dilakukan;</li>
          <li class="pb-2">d) Prinsip/kaedah/aplikasi/teknologi kecekapan tenaga yang digunakan;</li>
          <li class="pb-2">e) Senarai potensi penjimatan tenaga dan kaedah pegiraan potensi penjimatan tenaga dalam unit tenaga;</li>
          <li class="pb-2">f) Kaedah pengukuran dan pengiraan kuantiti penjimatan tenaga yang dicapai; dan</li>
          <li class="pb-2">g) Senarai langkah-langkah yang diambil dan aktiviti-aktiviti utama yang terlibat bersama tempoh masa setiap langkah dan aktiviti berkenaan dilaksanakan daripada mula hingga penjimatan tenaga dicapai;</li>
          <li class="pb-2">h) Analisa kewangan ringkas seperti Simple Payback Period, Return of Investment dan sebagainya.</li>
        </ol>

        <p class="text-lg pt-12">Panduan format laporan</p>


        <p class="text-lg pt-4">Laporan mesti ditaip dengan menggunakan kertas A4</p>
        <p class="text-lg pt-4">Bahasa penulisan: Bahasa Melayu atau Bahasa Inggeris.</p>
        <p class="text-lg pt-4">Jenis Tulisan: Times New Roman/Arial; saiz:12; Selangan:1.5</p>

        <p class="text-lg pt-4">(Sila sertakan surat pengesahan daripada majikan/wakil pepasangan yang di mana projek/tugas tersebut telah dijalankan)</p>

        <p class="text-lg pt-12">(iii)  Latihan/Kursus Berkaitan Kecekapan Tenaga Yang Pernah Disertai</p>
      
        </div>

        <div class="flex items-center justify-between mt-6">
          <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
            📜 <span class="text-indigo-600">Latihan/Kursus Berkaitan Kecekapan Tenaga</span>
          </h1>
          <a v-if="isDraft" class="btn-indigo cursor-pointer flex items-center px-5 py-3 mr-8 focus:text-indigo-500" @click="formCourses">
            <icon name="upload" class="mr-2 w-4 h-4 bf-w fill-white"/>Tambah Rekod
          </a> 
        </div>
              
        <div class="bg-white rounded-md shadow overflow-x-auto ml-8 mr-6 mb-16">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Nama Kursus</th>  
              <th class="pb-4 pt-6 px-6 text-center">Skop/Bidang Topik Kecekapan Tenaga</th>
              <th class="pb-4 pt-6 px-6 text-center">Tahun Kursus</th>
              <th class="pb-4 pt-6 px-6 text-center">tempoh Kursus</th>
              <th class="pb-4 pt-6 px-6 text-center">Organisasi Penyelia Kursus</th>
              <th class="pb-4 pt-6 px-6 text-center">Lain-lain Organisasi</th>
              <th class="pb-4 pt-6 px-6 text-center">Action</th>
            </tr>
            <tr v-for="course in courses" :key="course.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-t py-2 pb-2 pl-6">
                <span class="flex">{{ course.name }}</span>
                <icon v-if="course.deleted_at" name="trash" class="flex-shrink-0 ml-2 w-3 h-3 fill-gray-400" />
              </td>
              <td class="border-t text-center">
                <span>{{ course.course }}</span>   
              </td>
              <td class="border-t text-center">
                <span>{{ course.year }}</span>  
              </td>
              <td class="border-t text-center">
                <span>{{ course.duration }}</span>  
              </td>
              <td class="border-t text-center">
                <span>{{ course.organizer }}</span>  
              </td>
              <td class="border-t text-center">
                <span>{{ course.others }}</span>  
              </td>
              <td class="border-t text-center">
                <center>
                <a class="cursor-pointer flex justify-center px-5 py-3 mr-8 focus:text-indigo-500" @click="loadCourses(course)">
                  <icon name="process" class="mr-2 w-4 h-4 fill-indigo-400" />
                  Edit 
                </a>                
                </center>                      
              </td>
              <!-- <td v-if="form.owner" class="border-t text-center">
                ..
              </td> -->
            </tr>
            <tr v-if="courses.length === 0">
              <td class="px-6 py-4 border-t" colspan="7">
                <span class="flex justify-center py-2">
                  <icon name="notice" class="mr-2 w-4 h-4 fill-indigo-400" /> 
                  Tiada rekod kursus.&nbsp;&nbsp;
                  <a v-if="isDraft" class="cursor-pointer text-indigo-500" @click="formCourses()">
                    <strong>Tambah rekod</strong>
                  </a>
                </span>               
              </td>
            </tr>
          </table>
        </div>

        <textarea-input :disabled="!isDraft" style="height: 24vh;" v-model="form.field_knowledge" :error="form.errors.field_knowledge" class="pb-8 w-full" label="Bidang Pengetahuan dan Kelayakan Khusus Yang Dimiliki Dalam Pengurusan Tenaga Elektrik Dengan Cekap" />
        
        </tab-content>

        <tab-content title="Bahagian F : Rujukan">

            <div class="flex items-center justify-between mt-6">
              <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
                ✒️ <span class="text-indigo-600">Rujukan</span>
              </h1>
            </div>

            <span style="width: 100%;" class="pb-16 pr-12 flex items-center" ref="status">
              <span class="text-xl px-8">Sila nyatakan pihak yang boleh dirujuk oleh ECoS berkenaan pengalaman kerja atau tugas-tugas berkaitan pengurusan tenaga elektrik dengan cekap yang telah dilaksanakan.</span>             
            </span> 

            <div class="flex flex-wrap -mb-8 -mr-6 p-8">           

              <text-input :disabled="!isDraft" v-model="form.referral_name" :error="form.errors.referral_name" class="pb-8 pr-6 w-full" label="*Nama " />
              <text-input :disabled="!isDraft" v-model="form.referral_organization" :error="form.errors.referral_organization" class="pb-8 pr-6 w-full" label="Organisasi " />

              <text-input :disabled="!isDraft" v-model="form.referral_position" :error="form.errors.referral_position" class="pb-8 pr-6 w-full" label="Jawatan " />
              <text-input :disabled="!isDraft" v-model="form.referral_phone" :error="form.errors.referral_phone" class="pb-8 pr-6 w-full lg:w-1/2" label="*No. Telefon " />
              <text-input :disabled="!isDraft" v-model="form.referral_fax" :error="form.errors.referral_fax" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Fax " />


              <text-input :disabled="!isDraft" v-model="form.referral_email" :error="form.errors.referral_email" class="pb-8 pr-6 w-full lg:w-1/2" label="*Alamat Email " />
                  
              </div>

        
        </tab-content>

        <tab-content title="Bahagian G : Dokumen Sokongan (Muat Naik)">

        <div class="flex items-center justify-between mt-6">
            <h1 class="pl-8 w-100 pb-4 text-2xl font-bold">
              📄 <span class="text-indigo-600">Muat Naik Dokumen Sokongan</span>
            </h1>
        </div>

        <div class="bg-white rounded-md shadow overflow-x-auto p-8 mb-16">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
              <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen (pdf format)</th>
            </tr>
            <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-l border-t border-b pl-4">
                <a href="/Lampiran-A.pdf" target="_blank">Lampiran A</a> (Penerangan terperinci tentang tugas-tugas pengurusan tenaga elektrik dengan cekap yang dilaksanakan)
              </td>
              <td class="border-t border-b border-r pr-4">
                <div v-if="lampiran_a_upload" class="flex items-center">
                  <span style="width: 100%;" class="w-100 text-3xl font-bold">
                    <a class="text-xl cursor-pointer items-center flex py-4 pr-2 lg:w-1/2 focus:text-indigo-500" target="_blank" :href="managers.lampiran_a.attachment">
                    <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                      <small>View Document</small>
                    </a> 
                  </span>  
                  <a v-if="isDraft" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="remove(managers.lampiran_a.details)">
                    <icon name="trash" class="w-4 h-4 fill-indigo-400" />
                  </a>
                </div>
                <file-input :hidden="!isDraft" v-if="!lampiran_a_upload" v-model="form.lampiran_a" :error="form.errors.lampiran_a" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Lampiran A (pdf)" />
              </td>             
            </tr>
          </table>
        </div>  

        <div class="flex mt-6">
            <h1 class="pl-8 w-100 pb-4 text-xl font-bold">
              <span class="text-indigo-600">Sila aktifkan/<span style="font-style:italic">toggle button</span> kepada dokumen sokongan berikut yang akan dihantar kepada ECoS untuk proses semakan permohonan. Proses permohonan adalah tertakluk kepada penerimaan dokumen-dokumen sokongan seperti di senarai berikut:</span>
            </h1>
        </div>

        <div class="bg-white rounded-md shadow overflow-x-auto p-8 mb-16">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
              <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen</th>
            </tr>
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">
                Bayaran Fi
                <ol class="ml-4">
                  <li class="pt-2 pb-2">- Permohonan untuk pendaftaran sebagai pengurus tenaga elektrik RM 200.00 setiap permohonan.</li>
                  <li class="pb-2">- Pengeluaran Perakuan pendaftaran RM250.00 setahun.</li>
                </ol>
              </td>
              <td class="pb-4 pt-6 px-6 text-center">
                <div v-if="resit_pembayaran_upload" class="flex items-center">
                  <span style="width: 100%;" class="w-100 text-3xl font-bold">
                    <a class="text-xl cursor-pointer items-center flex py-4 pr-2 lg:w-1/2 focus:text-indigo-500" target="_blank" :href="managers.resit_pembayaran.attachment">
                    <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                      <small>View Document</small>
                    </a> 
                  </span>  
                  <a v-if="isDraft" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="remove(managers.resit_pembayaran.details)">
                    <icon name="trash" class="w-4 h-4 fill-indigo-400" />
                  </a>
                </div>
                <file-input :hidden="!isDraft" v-if="!resit_pembayaran_upload" v-model="form.resit_pembayaran" :error="form.errors.resit_pembayaran" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Resit Pembayaran (pdf)" />
              </td>
            </tr>
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Gambar berukuran passport (*jpg, *png) (Latar Belakang Biru)
                <!-- <ol class="ml-4">
                  <li class="pt-2 pb-2">- Kertas gambar tidak berkilat (gambar bukan instant).</li>
                  <li class="pb-2">- Calon memakai baju kemeja atau t-shirt berkolar (t-shirt berleher bulat tidak dibenarkan).</li>
                  <li class="pb-2">- Gambar yang tidak berukuran passport atau tidak menepati piawai tidak akan diterima.</li>
                </ol> -->
              </td>
              <td class="pb-4 pt-6 px-6 text-center">
                <div v-if="passport_photo_upload" class="flex items-center">
                  <span style="width: 100%;" class="w-100 text-3xl font-bold">
                    <a class="text-xl cursor-pointer items-center flex py-4 pr-2 lg:w-1/2 focus:text-indigo-500" target="_blank" :href="managers.passport_photo.attachment">
                    <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                      <small>View Document</small>
                    </a> 
                  </span>  
                  <a v-if="isDraft" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="remove(managers.passport_photo.details)">
                    <icon name="trash" class="w-4 h-4 fill-indigo-400" />
                  </a>
                </div>
                <file-input :hidden="!isDraft" v-if="!passport_photo_upload" v-model="form.passport_photo" :error="form.errors.passport_photo" class="py-2 w-full" type="file" accept="image/jpeg,image/gif,image/png,application/pdf,image/x-eps" label="*📎 Gambar Berukuran Passport (*jpg, *jpeg, *png)" />
              </td>
            </tr>
            <!-- <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Satu salinan K.P (depan dan belakang)yang disahkan.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton v-if="isDraft" 
                  class="float-right"
                    v-model="form.has_id" 
                    @on-change="toggleIdentified"
                    :is-active="isIdentified(has_id)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton>
                    <span v-if="!isDraft">{{ has_id }}</span> 
              </td>
            </tr> -->
            <!-- <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Salinan Ijazah/kelulusan setaraf yang disahkan.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton v-if="isDraft" 
                  class="float-right"
                    v-model="form.has_qualification" 
                    @on-change="toggleQualification"
                    :is-active="isQualified(has_qualification)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton>
                    <span v-if="!isDraft">{{ has_qualification }}</span> 
              </td>
            </tr>              -->
          </table>
        </div>

        <div class="flex mt-6">
            <h1 class="pl-8 w-100 pb-4 text-xl font-bold">
              <span class="text-indigo-600">Bagi pemohon yang memperolehi ijazah daripada institusi luar negara/institusi pendidikan swasta(IPTS), sila pastikan ijazah tersebut telah mendapat pengiktirafan / akreditasi daripada Kementerian Pendidikan Tinggi (KPT) / Jabatan Perkhidmatan Awam (JPA) / Agensi Kelayakan Malaysia (MQA) / Badan Profesional yang diiktiraf kerajaan Malaysia (BEM).</span>
            </h1>
        </div>

        <div class="bg-white rounded-md shadow overflow-x-auto p-8 mb-16">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
              <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen</th>
            </tr>
            <!-- <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Salinan Perakuan Kekompetenan ECoS yang sedia ada yang disahkan.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton v-if="isDraft" 
                  class="float-right"
                    v-model="form.has_competent" 
                    @on-change="toggleCompetent"
                    :is-active="isCompetent(has_competent)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton>
                    <span v-if="!isDraft">{{ has_competent }}</span> 
              </td>
            </tr> 
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Senarai dan penerangan lengkap pengalaman kerja seperti yang dikehendaki dalam Bahagian D.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton v-if="isDraft" 
                  class="float-right"
                    v-model="form.has_jobs_description" 
                    @on-change="toggleJobs"
                    :is-active="isJobs(has_jobs_description)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton>
                    <span v-if="!isDraft">{{ has_jobs_description }}</span> 
              </td>
            </tr>
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">
                <p>Senarai dan penerangan lengkap pengalaman kerja dan latihan berkaitan pengurusan tenaga elektrik</p>
                <p class="mt-4">dengan cekap seperti yang dikehendaki dalam Bahagian E(i),(ii),(iii)dan (iv).</p>
              </td>
              <td class="pb-4 pt-6 px-6 text-center">
                <Vue3ToggleButton v-if="isDraft" 
                  class="float-right"
                    v-model="form.has_jobs_experience" 
                    @on-change="toggleExperienced"
                    :is-active="isExperienced(has_jobs_experience)" 
                    :trackColor="'#ccc'" 
                    :track-active-color="'#d9efe0'" 
                    :handleColor="'#2f5a5b'"></Vue3ToggleButton>
                    <span v-if="!isDraft">{{ has_jobs_experience }}</span>     
              </td>
            </tr> -->
            <tr class="text-left font-bold">
              <td class="pb-4 pt-6 px-6 text-left">Surat pengesahan yang berkenaan daripada majikan/pihak pepasangan.</td>
              <td class="pb-4 pt-6 px-6 text-center">
                <div v-if="surat_pengesahan_upload" class="flex items-center">
                  <span style="width: 100%;" class="w-100 text-3xl font-bold">
                    <a class="text-xl cursor-pointer items-center flex py-4 pr-2 lg:w-1/2 focus:text-indigo-500" target="_blank" :href="managers.surat_pengesahan.attachment">
                    <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                      <small>View Document</small>
                    </a> 
                  </span>  
                  <a v-if="isDraft" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="remove(managers.surat_pengesahan.details)">
                    <icon name="trash" class="w-4 h-4 fill-indigo-400" />
                  </a>
                </div>
                <file-input :hidden="!isDraft" v-if="!surat_pengesahan_upload" v-model="form.surat_pengesahan" :error="form.errors.surat_pengesahan" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Surat Pengesahan Majikan (pdf format)" />
              </td>
            </tr>             
          </table>
        </div>

        </tab-content>

        <tab-content title="Bahagian H : Pengakuan">

        <div class="flex items-center justify-between mt-6">
          <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
            ✒️ <span class="text-indigo-600">Pengakuan Pemohon</span>
          </h1>
        </div>

        <span style="width: 100%;" class="pb-16 pr-12 flex items-center" ref="status">
          <span class="text-xl px-8">Saya mengaku bahawa kenyataan diberikan di dalam borang ini dan dokumen yang disertakan adalah benar seperti yang dikehendaki dan ECoS berhak menolah permohonan ini jika didapati keterangan dan dokumen yang diberikan adalah tidak lengkap, tidak benar, palsu atau tidak disertakan butir-butir yang dikehendaki.</span>             
          <Vue3ToggleButton v-if="isDraft" 
          class="float-right"
            v-model="form.is_declared" 
            @on-change="toggleStatus"
            :is-active="isDeclared(is_declared)" 
            :trackColor="'#ccc'" 
            :track-active-color="'#d9efe0'" 
            :handleColor="'#2f5a5b'"></Vue3ToggleButton>
            <span v-if="!isDraft">{{ is_declared  }}</span>  
        </span>
        
        <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Nama Pemohon</th>
              <th class="pb-4 pt-6 px-6 text-center">Tarikh</th>
            </tr>
            <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-l border-t border-b pl-4 text-center">
                <span class="text-xl pt-4">{{ form.name }}</span>
              </td>
              <td class="border-t border-b border-r pr-4 text-right">
                <Datepicker :disabled="!isDraft" 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.date_declared"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Pengakuan"></Datepicker>
              </td>
            </tr>
        </table>
     
        <div class="flex items-center justify-between mt-6">
          <h1 class="pl-8 w-100 pb-10 text-2xl font-bold">
            ✒️ <span class="text-indigo-600">Pengakuan Majikan Sekarang</span>
          </h1>
        </div>

        <span style="width: 100%;" class="pb-16 pr-12 flex items-center" ref="status">
          <span class="text-xl px-8">Adalah didapati sepanjang pengetahuan saya,butir-butir yang dinyatakan di dalam borang ini adalah benar.</span>             
          <Vue3ToggleButton v-if="isDraft" 
          class="float-right"
            v-model="form.is_acknowledged" 
            @on-change="toggleAcknowledge"
            :is-active="isAcknowledged(is_acknowledged)" 
            :trackColor="'#ccc'" 
            :track-active-color="'#d9efe0'" 
            :handleColor="'#2f5a5b'"></Vue3ToggleButton>
          <span v-if="!isDraft">{{ is_acknowledged  }}</span>   
        </span>
        
        <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Butiran</th>
              <th class="pb-4 pt-6 px-6 text-center">Jawatan</th>
              <th class="pb-4 pt-6 px-6 text-center">Tarikh</th>
            </tr>
            <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-l border-t border-b pl-4 text-center">
                <text-input :disabled="!isDraft" v-model="form.employer_name" :error="form.errors.employer_name" class="pb-8 pr-6 w-full" label="Nama Pegawai " />
              </td>
              <td class="border-l border-t border-b pl-4 text-center">
                <text-input :disabled="!isDraft" v-model="form.employer_position" :error="form.errors.employer_position" class="pb-8 pr-6 w-full" label="Jawatan Pegawai " />
              </td>
              <td class="border-t border-b border-r pr-4 text-center">
                <Datepicker :disabled="!isDraft" 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.date_acknowledged"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Pengesahan"></Datepicker>
              </td>
            </tr>
        </table>

        </tab-content>

      </form-wizard>    
      
    </div>
    
    <Modal @close="toggleCompetentPerson" :modalActive="modalCompetentPerson" @submit="updateCompetentPerson">
      <div class="mx-6 pb-4">          
          <span class="flex items-center py-3 mb-6">
            <icon name="profile" class="mr-4 w-8 h-8 text-gray-700"/>
            <h1 style="width: 100%;" class="text-2xl font-bold">Perakuan Kekompetenan Sedia Ada</h1>
            <button v-if="this.competent == 'update'" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('competents', form.competent_id)">
              <icon name="trash" class="w-4 h-4 fill-indigo-400 mr-2" /> Delete Record
            </button>
          </span> 
          
          <div class="flex flex-wrap mr-6 p-8">
            <text-input v-model="form.competent_name" :error="form.errors.competent_name" class="pb-8 pr-6 w-full" label="Perakuan Kekompeten" />
            <text-input v-model="form.competent_certificate" :error="form.errors.competent_certificate" class="pb-8 pr-6 w-full lg:w-1/2" label="No. Perakuan " />
            <select-input v-model="form.competent_restriction" :error="form.errors.competent_restriction" class="pb-8 pr-6 w-full lg:w-1/2" label="Sekatan ">
                  <option :value="null" />
                  <option value="Terhad">Terhad</option>
                  <option value="Terbuka">Terbuka</option>
            </select-input> 
            <Datepicker 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.competent_cert_date"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Dikeluarkan"></Datepicker>
            <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
              <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen (pdf format)</th>
            </tr>
            <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
              <td class="border-l border-t border-b pl-4">
                Salinan perakuan kekompetenan (Pengurus Tenaga)
              </td>
              <td class="border-t border-b border-r pr-4">
                <div v-if="certificate_upload" class="flex items-center">
                  <span style="width: 100%;" class="w-100 text-3xl font-bold">
                    <a @click="loadAttachment('competent_document_certificate', competent)" class="text-xl cursor-pointer items-center flex py-4 pr-2 lg:w-1/2 focus:text-indigo-500">  
                    <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                      View Document 
                    </a> 
                  </span>  
                  <a class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeAttachment('competent_document_certificate', competent)">
                    <icon name="trash" class="w-4 h-4 fill-indigo-400" />
                  </a>
                </div>
                <file-input v-if="!certificate_upload" v-model="form.competent_document_certificate" :error="form.errors.competent_document_certificate" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Perakuan kekompetenan - Pengurus Tenaga (pdf)" />
              </td>             
            </tr>
          </table>
          </div> 
      </div>    
    </Modal> 

    <Modal @close="toggleAcademics" :modalActive="modalAcademics" @submit="updateAcademics">
      <div class="mx-6">
          
          <span class="flex items-center py-3 mb-6">
            <icon name="eligibility" class="mr-4 w-8 h-8 text-gray-700"/>
            <h1 style="width: 100%;" class="text-2xl font-bold">Kelayakan Akademik (Ijazah/Kelulusan yang setaraf)</h1>
            <button v-if="this.academic == 'update'" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('academics', form.academic_id)">
              <icon name="trash" class="w-4 h-4 fill-indigo-400 mr-2" /> Delete Record
            </button>
          </span> 
          
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.academic_name" :error="form.errors.academic_name" class="pb-8 pr-6 w-full" label="Nama Ijazah/Kelulusan yang setaraf " />
            <text-input v-model="form.academic_course" :error="form.errors.academic_course" class="pb-8 pr-6 w-full lg:w-1/2" label="Nama Institusi/Universiti " />
            <Datepicker 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.academic_cert_date"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Lulus"></Datepicker>

                <table class="w-full whitespace-nowrap">
                <tr class="text-left font-bold">
                  <th class="pb-4 pt-6 px-6 text-center">Senarai Dokumen Sokongan</th>
                  <th class="pb-4 pt-6 px-6 text-center">Muat Naik Dokumen (pdf format)</th>
                </tr>
                <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
                  <td class="border-l border-t border-b pl-4">
                    Salinan Ijazah/kelulusan setaraf yang disahkan.
                  </td>
                  <td class="border-t border-b border-r pr-4">
                    <div v-if="academic_upload" class="flex items-center">
                      <span style="width: 100%;" class="w-100 text-3xl font-bold">
                        <a @click="loadAttachment('academic_document_certificate', academic)" class="text-xl cursor-pointer items-center flex py-4 pr-2 lg:w-1/2 focus:text-indigo-500">  
                        <icon name="adobe" class="mr-2 w-4 h-4 fill-indigo-400" />
                          View Document 
                        </a> 
                      </span>  
                      <a class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeAttachment('academic_document_certificate', academic)">
                        <icon name="trash" class="w-4 h-4 fill-indigo-400" />
                      </a>
                    </div>
                    <file-input v-if="!academic_upload" v-model="form.academic_document_certificate" :error="form.errors.academic_document_certificate" class="py-2 w-full" type="file" accept="application/pdf" label="*📎 Salinan Ijazah / Kelulusan (pdf)" />
                  </td>             
                </tr>
              </table>                

          </div>
      </div>    
    </Modal> 

    <Modal @close="toggleExperiences" :modalActive="modalExperiences" @submit="updateExperiences">
      <div class="mx-6">
          
          <span class="flex items-center py-3 mb-6">
            <icon name="experience" class="mr-4 w-8 h-8 text-gray-700"/>
            <h1 style="width: 100%;" class="text-2xl font-bold">Rekod Pengalaman Kerja Pemohon</h1>
            <button v-if="this.experience == 'update'" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('experiences', form.experience_id)">
              <icon name="trash" class="w-4 h-4 fill-indigo-400 mr-2" /> Delete Record
            </button>
          </span> 
          
          <div class="flex flex-wrap -mb-8 -mr-6 p-8">
            <text-input v-model="form.experience_name" :error="form.errors.experience_name" class="pb-8 pr-6 w-full" label="Nama Majikan " />
            <text-input v-model="form.experience_address" :error="form.errors.experience_address" class="pb-8 pr-6 w-full" label="Alamat Majikan " />
            <text-input v-model="form.experience_position" :error="form.errors.experience_position" class="pb-8 pr-6 w-full" label="Jawatan yang disandang " />
            <text-input v-model="form.experience_jobs" :error="form.errors.experience_jobs" class="pb-8 pr-6 w-full" label="Bidang Tugas " />
            <Datepicker 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.experience_start_date"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Mula"></Datepicker>
              <Datepicker 
                class="pt-6 pb-6 pr-4 lg:w-1/2"  
                v-model="form.experience_end_date"
                format="dd-MM-yyyy"
                @closed="runme()"
                placeholder="Tarikh Tamat"></Datepicker>
          </div> 
      </div>    
    </Modal> 

    <Modal @close="toggleModal" :modalActive="modalActive" @submit="toggleModal">
          <div class="mx-6">
            <table class="w-full">
            <thead>
              <tr class="text-left font-bold">
                <th class="pb-2">
                  <div class="flex items-center justify-between mb-4">
                    <h1 class="text-2xl font-bold">💬&nbsp;Feedbacks ({{feedbacks.total}})</h1>
                  </div>  
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="feedback in feedbacks.data" :key="feedback.id" class="hover:bg-gray-100 focus-within:bg-gray-100">
                <td class="border-t py-2 pb-2">
                  <span class="pb-8 pr-6 w-full">
                    <span class="group flex py-2">
                      <icon  :name="feedback.user == 'owner' ? 'feedback' : 'comments'" class="w-6 h-6" :class="fill-indigo-400" />
                      <span class="ml-2 mt-2">{{feedback.user}}</span>
                    </span>
                    <div class="pb-3 rounded text-small">{{feedback.message}}</div>
                    <span>{{feedbackSubmitted(feedback.created, false)}} ({{feedbackSubmitted(feedback.created, true)}})</span>
                  </span>              
                </td>
              </tr>
              <tr v-if="feedbacks.total === 0">
                <td class="px-6 py-4 border-t">No feedbacks at the moment.</td>
              </tr>
            </tbody>
          </table>
          <div class="flex items-center justify-between mt-4 p-4 bg-gray-100 rounded">
            <text-input v-model="form.message" :error="form.errors.message" class="pb-4 pr-4 w-full" label="Write your comments ..." />
            
            <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="button" @click.prevent="postComment()">💬&nbsp;Post Comment</loading-button>
          </div>
          </div>
          <pagination class="mt-6" :links="feedbacks.links"/>
        </Modal>
        
        <Modal @close="closeProcessForm" :modalActive="modalProcess" @submit="closeProcessForm">
          <div class="mx-6">
            <h1 class="text-2xl font-bold">📜&nbsp;Process REEM Application</h1>
            <step-progress v-if="process" :line-thickness="5" :steps="progress" :current-step="currentStep" icon-class="fa fa-check"></step-progress>
                      
            <!-- process -->

            <div v-if="form.status == 'approved'" class="flex items-center justify-between mt-4 p-4 bg-gray-100 rounded"> 
              <text-input v-model="form.certification" :error="form.errors.certification" class="pb-4 pr-6 w-full lg:w-1/2" label="ECoS REEM ID " />
              <text-input v-model="form.expiry" :error="form.errors.expiry" class="pb-4 pr-6 w-full lg:w-1/2" label="Expiry ~ One (1) year upon approval " />
            </div> 

            <div class="flex items-center justify-between mt-4 p-4 bg-gray-100 rounded">
              <text-input v-model="form.message" :error="form.errors.message" class="pb-4 pr-4 w-full" label="Add Remarks ... " />
              <select-input @change="changeStatus" v-model="form.status" :error="form.errors.status" class="pb-4 pr-6 w-full lg:w-1/2" label="Status ">
                <option v-for="operation in operations" :key="operation" :value="operation">{{ operation }}</option>
              </select-input>
              <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="button" @click="updateSubmission">💬&nbsp;Update Status</loading-button>
            </div>
          
          </div>
        </Modal>        

        <Modal @close="toggleCourses" :modalActive="modalCourses" @submit="updateCourses">
          <div class="mx-6">
              
              <span class="flex items-center py-3 mb-6">
                <icon name="eligibility" class="mr-4 w-8 h-8 text-gray-700"/>
                <h1 style="width: 100%;" class="text-2xl font-bold">Latihan/Kursus Berkaitan Kecekapan Tenaga Yang Pernah Disertai</h1>
                <button v-if="this.course == 'update'" class="btn-indigo cursor-pointer flex items-center px-4 py-4 focus:text-indigo-500" @click="removeRecord('courses', form.course_id)">
                  <icon name="trash" class="w-4 h-4 fill-indigo-400 mr-2" /> Delete Record
                </button>
              </span> 
              
              <div class="flex flex-wrap -mb-8 -mr-6 p-8">
                <text-input v-model="form.course_name" :error="form.errors.course_name" class="pb-8 pr-6 w-full" label="Nama Kursus " />
                <text-input v-model="form.course_scope" :error="form.errors.course_scope" class="pb-8 pr-6 w-full" label="Skop/Bidang Topik Kecekapan Tenaga " />
                <Datepicker 
                    class="pt-6 pb-6 pr-4 lg:w-1/2"  
                    v-model="form.course_year"
                    format="yyyy"
                    year-only=true
                    @closed="runme()"
                    placeholder="Tahun"></Datepicker>
                <text-input v-model="form.course_duration" :error="form.errors.course_duration" class="pb-8 pr-6 w-full lg:w-1/2" label="Tempoh Kursus " />
                <text-input v-model="form.course_organizer" :error="form.errors.course_organizer" class="pb-8 pr-6 w-full" label="Organisasi Penyelia Kursus " />
                <text-input v-model="form.course_others" :error="form.errors.course_others" class="pb-8 pr-6 w-full" label="Lain-lain Organisasi " />
              </div> 
          </div>    
        </Modal> 

    </form>

  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import { ref } from "vue";
import Layout from '@/Shared/Layout'
import TextareaInput from '@/Shared/TextareaInput'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'
import {FormWizard, TabContent} from 'vue3-form-wizard'
import '../../../../node_modules/vue3-form-wizard/dist/style.css'
//import '../../../../node_modules/vue-form-wizard/dist/vue-form-wizard.js'
import Icon from '@/Shared/Icon'
import Modal from "@/Shared/Modal.vue"
import Pagination from '@/Shared/Pagination'
import axios from 'axios'
import AvatarInput from '@/Shared/AvatarInput'
import { Vue3ToggleButton } from 'vue3-toggle-button'
import '../../../../node_modules/vue3-toggle-button/dist/style.css'
import moment from 'moment'
import StepProgress from 'vue-step-progress';
import 'vue-step-progress/dist/main.css';
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import QrcodeVue from 'qrcode.vue'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
    FileInput,
    FormWizard,
    AvatarInput,
    TabContent,
    Modal,
    Pagination,
    Icon,
    Vue3ToggleButton,
    StepProgress,
    Datepicker,
    QrcodeVue,
  },
  layout: Layout,
  props: {
    managers: Object,
    feedbacks: Object,
    owner: Object,
  },
  remember: 'form',
  setup() {

    let params = new URLSearchParams(window.location.search)
    const modalActive = ref(true);
    
    if(params.size==0){
      modalActive.value = false  
    }else{
      modalActive.value = true  
    } 

    const toggleModal = () => {     
      modalActive.value = !modalActive.value;
    };

    const modalCompetentPerson = ref(false);
    const modalAcademics = ref(false);
    const modalExperiences = ref(false);
    const modalProcess = ref(false);  
    const modalCourses = ref(false);

    const toggleAcademics = () => {
      modalAcademics.value = !modalAcademics.value;
    };

    const toggleCompetentPerson = () => {
      modalCompetentPerson.value = !modalCompetentPerson.value;
    };

    const toggleExperiences = () => {
      modalExperiences.value = !modalExperiences.value;
    };

    const toggleProcess = () => {
      modalProcess.value = !modalProcess.value;
    };

    const toggleCourses = () => {
      modalCourses.value = !modalCourses.value;
    };


    return { modalActive, toggleModal, 
             modalAcademics, toggleAcademics, 
             modalCompetentPerson, toggleCompetentPerson, 
             modalExperiences, toggleExperiences,
             modalCourses, toggleCourses,
             modalProcess, toggleProcess };
  },
  data() {
    return {
      form: this.$inertia.form({
        category: this.managers.category,
        name: this.managers.name,
        photo: this.managers.photo,
        name: this.managers.name,
        ic_no: this.managers.ic_no,
        ic_copy: this.managers.ic_copy,
        id_no: this.managers.id_no,
        type: this.managers.type,
        birthday: this.managers.birthday,
        gender: this.managers.gender,
        address: this.managers.address,
        city: this.managers.city,
        postal_code: this.managers.postal_code,
        region: this.managers.region,
        mail_address: this.managers.mail_address,
        mail_city: this.managers.mail_city,
        mail_poscode: this.managers.mail_poscode,
        mail_state: this.managers.mail_state,
        phone_no: this.managers.phone_no,
        phone: this.managers.phone,
        email: this.managers.email,
        company_name: this.managers.company_name,
        company_address: this.managers.company_address,
        company_city: this.managers.company_city,
        company_poscode: this.managers.company_poscode,
        company_state: this.managers.company_state,
        company_phone: this.managers.company_phone,
        company_fax: this.managers.company_fax,
        website: this.managers.website,
        position: this.managers.position,
        my_engineering_register: this.managers.my_engineering_register,
        my_engineering_reff: this.managers.my_engineering_reff,
        field_knowledge:  this.managers.field_knowledge,
        academic_id: null, //*Form Fields*
        academic_name: null, //*Form Fields*
        academic_course: null, //*Form Fields*
        academic_cert_date: null, //*Form Fields*
        academic_document_certificate: null,
        competent_id: null, 
        competent_name: null, 
        competent_certificate: null,
        competent_document_certificate: null,
        competent_restriction: null,
        competent_cert_date: null,
        experience_id: null, 
        experience_name: null, 
        experience_address: null, 
        experience_position: null, 
        experience_jobs: null,
        experience_start_date: null,
        experience_end_date: null,
        course_id: null, 
        course_name: null, 
        course_course: null, 
        course_scope: null, 
        course_year: null, 
        course_duration: null, 
        course_organization: null, 
        course_others: null,
        referral_name: this.managers.referral_name,
        referral_organization: this.managers.referral_organization,
        referral_position: this.managers.referral_position,
        referral_phone: this.managers.referral_phone,
        referral_fax: this.managers.referral_fax,
        referral_email: this.managers.referral_email, 
        lampiran_a: this.managers.lampiran_a,
        resit_pembayaran: this.managers.resit_pembayaran,
        passport_photo: this.managers.passport_photo,
        surat_pengesahan: this.managers.surat_pengesahan,
        is_declared: this.managers.is_declared,
        is_mailing: this.managers.is_mailing,
        has_fees: this.managers.has_fees,
        has_photos: this.managers.has_photos,
        has_id: this.managers.has_id,
        has_qualification: this.managers.has_qualification,
        has_competent: this.managers.has_competent,
        has_jobs_description: this.managers.has_jobs_description,
        has_jobs_experience: this.managers.has_jobs_experience,
        has_employer_acknowledged: this.managers.has_employer_acknowledged,
        is_acknowledged: this.managers.is_acknowledged,
        is_paid: this.managers.has_fees,
        date_declared: this.managers.date_declared,
        employer_attachment: this.managers.employer_attachment,
        date_acknowledged: this.managers.date_acknowledged,
        employer_name: this.managers.employer_name,
        employer_position: this.managers.employer_position,
        certification: this.managers.certification,
        expiry: this.certExpiry(this.managers.expiry),
      }),
      managers_id: this.managers.id, //Interim Company ID
      competent: {},
      competents:this.managers.competents,
      competent__: {},
      academic: {},  // Object Action
      academics: this.managers.academics, // Object Array List
      academic__: {},
      experience: {},
      experiences:this.managers.experiences,
      course: {},  // Object Action
      courses: this.managers.courses, // Object Array List
      is_mailing: false,
      is_declared: this.managers.is_declared,
      is_acknowledged: this.managers.is_acknowledged,
      is_paid: this.managers.has_fees,
      has_photos: this.managers.has_photos,
      has_id: this.managers.has_id,
      has_qualification: this.managers.has_qualification,
      has_competent: this.managers.has_competent,
      has_jobs_description: this.managers.has_jobs_description,
      has_jobs_experience: this.managers.has_jobs_experience,
      has_employer_acknowledged: this.managers.has_employer_acknowledged,
      certificate_upload: false,
      academic_upload : false,
      lampiran_a_upload: (this.managers.lampiran_a)? true : false,
      resit_pembayaran_upload:  (this.managers.resit_pembayaran)? true : false,
      passport_photo_upload:  (this.managers.passport_photo)? true : false, 
      surat_pengesahan_upload :   (this.managers.surat_pengesahan)? true : false,  
      ic_copy_upload: (this.managers.ic_copy)? true : false,
      new_entries : [],
      process : false,
      currentStep : 0,
      operations : [],
      status : this.managers.status,
      isDraft : this.managers.is_draft,
      qrcode: "http://eeisy.ecos.servces",
    }
  },
  mounted(){
    var wizard = this.$refs.wizard
    wizard.activateAll()
    
    const baseUrl = window.location.origin;
    this.qrcode = baseUrl + "/verify-certificate/" + this.managers.url_hash;
        
    /* 
    let isValid = this.checkImageUrl(this.form.photo, function(isValid) {return isValid });
    if(!isValid){
      this.urlToBlob(this.managers.no_photo).then(blob => {
        this.form.photo = blob;
      });
    }
    */
 
    if(this.owner){
      this.isDraft = false;
    }

    let action = this.managers.action;
    action.forEach((item) => {
      this.operations.push(item.action)      
    });
    this.progress = this.operations

  }, 
  methods: {
    submitForm(){
      if (confirm('Sila pastikan semua maklumat yang diperlukan dan dokumen sokongan telah disertakan. Teruskan untuk menghantar laporan ini?')) {
        this.update();
        this.form.submitting = true;
        this.form.post(`/reem/${this.managers.id}/submission`, {
        onSuccess: () => {
          this.form.submitting = false
          this.form.saving = false
        },
      }) 
      }     
    },
    update() {

      this.form.saving = true

      if(this.competents.length>0){
        this.competents.forEach((competent) => {
          if (competent?.record === undefined) {
            this.postCompetent(competent)
          }
        }); 
      }

      if(this.academics.length>0){
        this.academics.forEach((academic) => {
          if (academic?.record === undefined) {
            this.postAcademic(academic) 
          }
        });
      }

      if(this.experiences.length>0){
        this.experiences.forEach((experience) => {
          if (experience?.record === undefined) {
            this.postExperience(experience);
          }
        }); 
      }

      if(this.courses.length>0){
        this.courses.forEach((course) => {
          if (course?.record === undefined) {
            this.postCourse(course) 
          }
        });
      }

      this.form.post(`/reem/${this.managers.id}`, {
        onSuccess: () => {
          this.form.saving = false
        },
      }) 
      
      
    },
    runme(){

    }, 
    destroy() {
      if (confirm('Are you sure you want to delete this organization?')) {
        this.$inertia.post(`/reem/${this.managers.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this organization?')) {
        this.$inertia.put(`/reem/${this.managers.id}/restore`)
      }
    },
    onComplete(){
      alert("Form Complete!");
      this.update();
    },
    feedbackSubmitted(timestamp, standard){
        if(standard){
          return moment(timestamp).fromNow();
        }else{
          return moment(timestamp).format("hh:mm ddd, D MMM Y")
        }
    },
    loadFeedbacks(){
      this.toggleModal()
    },
    postComment(){        
      if(this.form.message.trim() == "") {
        this.form.errors.message = "cannot post blank messages..."
        return;
      }
      this.form.processing = true

      const data = {
        message: this.form.message,
      };

      axios.post(`/reem/${this.managers.id}/feedbacks`, data)
        .then(response => {
          this.$emit('update:feedbacks', response.data.data);
          this.$inertia.visit(window.location, { data: { page: 1 } });
          this.form.reset('message')
          this.form.processing = false
        })
        .catch(error => { });

    },
    formatDate(timestamp){
      return moment(timestamp).format("DD-MM-Y")
    },
    checkProcess(process){
      let listWorkFlow = this.managers.workflows;
      let newLabel = "";
      var hasUpdate = false;
      listWorkFlow.forEach((wf) => {
          if(wf.process == process) {
            newLabel = process  + " (" + this.formatDate(wf.created_at) + ")";
            hasUpdate = true; 
          }
        });
      if(hasUpdate){
        return newLabel;
      }else{
        return process; 
      }
    },
    closeProcessForm(){
      this.form.errors.status = "";
      this.toggleProcess()
    },
    processSubmission(){
      this.process = true;
      
      if(this.form.certification == "" || this.form.certification == null){
        this.form.certification = "EREEM-#####-2024"
      }
      //Update Labels : this.process
      let listProc = this.progress;
      let merged = [];
      listProc.forEach((proc) => {
        merged.push(this.checkProcess(proc))
      });
      this.progress = merged; 

      let listWorkFlow = this.managers.workflows;
      this.currentStep = 0;
      listWorkFlow.forEach((item) => {
        let action = this.managers.action;
        action.forEach((op) => {
          if(item.process == op.action) {
            this.currentStep = parseInt(op.weight);
          }
        });
      });
      this.toggleProcess()
    },
    updateSubmission(){
      
      if (typeof this.form.status === 'undefined') {
        this.form.errors.status = "no status selected";
        return;
      }

      
      this.form.processing = true;
      
      var rawDate = moment(this.form.expiry, "DD-MM-YYYY");
      
      const data = {
        target_id: this.managers.id,
        status: this.form.status,
        message: this.form.message,
        certification: this.form.certification,
        expiry: moment(rawDate).format("yyyy-MM-DD"),
      };
      
      axios.post(`/reem/${this.managers.id}/workflows`, data)
        .then(response => {
          this.form.processing = false
          if(response.data.status == 'success'){
            this.toggleProcess()
            this.$page.props.flash.success = response.data.message
          }
        })
        .catch(error => { });

    },
    changeStatus(){
        if(this.form.status == 'approved'){
          var dt_current = moment();
          let new_expiry = dt_current.add(1, 'years').subtract(1, 'days').format('DD-MM-Y');
          this.form.expiry = new_expiry
        }
    },
    loadCompetent(competent){
      this.competent__ = competent; 
      this.certificate_upload = (competent.competent_document_certificate)? true : false
      this.competent = "update"
      this.form.competent_id = competent.id;
      this.form.competent_name = competent.name;
      this.form.competent_certificate = competent.cert_no;
      this.form.competent_restriction = competent.competent_restriction;
      this.form.competent_document_certificate = competent.competent_document_certificate,
      this.toggleCompetentPerson()
    },
    formCompetentPerson(){
      this.competent__ = {};
      this.certificate_upload = false; 
      this.competent = "create";
      this.form.competent_id = "";
      this.form.competent_name = "";
      this.form.competent_certificate = "";
      this.form.competent_restriction = "";
      this.form.competent_document_certificate = "";
      this.toggleCompetentPerson()
    },
    updateCompetentPerson(){
      if(this.competent == "create"){
        this.form.competent_id = Math.floor(new Date().valueOf() * Math.random());
        let competent = {id:this.form.competent_id,
                          record: "create",
                            name:this.form.competent_name,
                            cert_no: this.form.competent_certificate,
                            competent_restriction: this.form.competent_restriction,
      competent_document_certificate : this.form.competent_document_certificate,
                          }
        this.competents.push(competent);
        this.postCompetent(competent)
      }else{
        this.competents.forEach((competent) => {
          if(competent.id == this.form.competent_id){
            competent.name = this.form.competent_name;
            competent.cert_no = this.form.competent_certificate;
            competent.competent_restriction = this.form.competent_restriction;
            competent.competent_document_certificate = this.form.competent_document_certificate;
            this.postCompetent(competent)
          } 
        }); 
      }
      this.toggleCompetentPerson()
    },    
    loadAcademic(academic){
      this.academic__ = academic; 
      this.academic_upload = (academic.academic_document_certificate)? true : false
      this.academic = "update";
      this.form.academic_id = academic.id;
      this.form.academic_name = academic.name;
      this.form.academic_course = academic.course;
      this.form.academic_cert_date = academic.cert_date;
      this.toggleAcademics()
    },
    formAcedemics(){
      this.academic__ = {};
      this.academic_upload = false; 
      this.academic = "create";
      this.form.academic_id = "";
      this.form.academic_name = "";
      this.form.academic_course = "";
      this.form.academic_cert_date = "";
      this.form.academic_document_certificate = "";
      this.toggleAcademics()
    },
    updateAcademics(){
      if(this.academic == "create"){
        this.form.academic_id = Math.floor(new Date().valueOf() * Math.random());
        let academic = {id:this.form.academic_id,
                         record: "create",
                           name:this.form.academic_name,
                           course: this.form.academic_course,
                           cert_date: moment(this.form.academic_cert_date).format("yyyy-MM-DD"),
                           academic_document_certificate : this.form.academic_document_certificate,
                          };
        this.academics.push(academic);
        this.postAcademic(academic);                  
      }else{
        this.academics.forEach((academic) => {
          if(academic.id == this.form.academic_id){
            academic.name = this.form.academic_name;
            academic.course = this.form.academic_course;
            academic.cert_date = moment(this.form.academic_cert_date).format("yyyy-MM-DD");
            academic.academic_document_certificate = this.form.academic_document_certificate;
            this.postAcademic(academic);   
          }  
        }); 
      }     
      this.toggleAcademics()
    },
    loadExperience(experience){
      this.experience = "update";
      this.form.experience_id = experience.id;
      this.form.experience_name = experience.name;
      this.form.experience_address = experience.address;
      this.form.experience_position = experience.position;
      this.form.experience_jobs = experience.jobs;
      this.form.experience_start_date = experience.start_date;
      this.form.experience_end_date = experience.end_date;
      this.toggleExperiences()
    },
    formExperiences(){
      this.experience = "create";
      this.form.experience_id = "";
      this.form.experience_name = "";
      this.form.experience_address = "";
      this.form.experience_position = "";
      this.form.experience_jobs = "";
      this.form.experience_start_date = "";
      this.form.experience_end_date = "";
      this.toggleExperiences()
    },
    updateExperiences(){
      if(this.experience == "create"){
        this.form.experience_id = Math.floor(new Date().valueOf() * Math.random());
        let experience = {id:this.form.experience_id,
                         record: "create",
                         name:this.form.experience_name,
                         address:this.form.experience_address,
                         position:this.form.experience_position,
                        jobs:this.form.experience_jobs,
                       start_date: moment(this.form.experience_start_date).format("yyyy-MM-DD"),
                         end_date: moment(this.form.experience_end_date).format("yyyy-MM-DD"),
                          };
        this.experiences.push(experience);
        this.postExperience(experience);                  
      }else{
        this.experiences.forEach((experience) => {
          if(experience.id == this.form.experience_id){
            experience.name = this.form.experience_name;
            experience.address = this.form.experience_address;
            experience.position = this.form.experience_position; 
            experience.jobs = this.form.experience_jobs; 
            experience.start_date = moment(this.form.experience_start_date).format("yyyy-MM-DD");
            experience.end_date = moment(this.form.experience_end_date).format("yyyy-MM-DD");
            this.postExperience(experience);
          }  
        }); 
      }
      this.toggleExperiences()
    },
    loadCourses(course){
      this.course = "update";
      this.form.course_id = course.id;
      this.form.course_name = course.name;
      this.form.course_scope = course.scope;
      this.form.course_year = course.year;
      this.form.course_duration = course.duration;
      this.form.course_organizer = course.organizer;
      this.form.course_others = course.others;
      this.toggleCourses()
    },
    formCourses(){
      this.course = "create";
      this.form.course_id = "";
      this.form.course_name = "";
      this.form.course_scope = "";
      this.form.course_year = "";
      this.form.course_duration = "";
      this.form.course_organizer = "";
      this.form.course_others = "";
      this.toggleCourses()
    },
    updateCourses(){
      if(this.course == "create"){
        this.form.course_id = Math.floor(new Date().valueOf() * Math.random());
          let course = {id:this.form.course_id,
                        record: "create",
                        name:this.form.course_name,
                        course: this.form.course_course,
                        scope: this.form.course_scope,
                        year: moment(this.form.course_year).format("yyyy"),
                        duration: this.form.course_duration,
                        organizer: this.form.course_organizer,
                        others: this.form.course_others,
                      };
        this.courses.push(course);
        this.postCourse(course);                  
      }else{
        this.courses.forEach((course) => {
          if(course.id == this.form.course_id){
                        course.name = this.form.course_name;
                        course.course = this.form.course_course;
                        course.scope = this.form.course_scope;
                        course.year = moment(this.form.course_year).format("yyyy");
                        course.duration = this.form.course_duration;
                        course.organizer = this.form.course_organizer;
                        course.others = this.form.course_others;
            this.postCourse(course);   
          }  
        }); 
      }
      this.toggleCourses()
    },
    fileChanged(target){
      if(target=='ic_copy'){
        if(this.form.ic_copy){
        
        }
        
      }
    },
    remove(attachment){
      
      if (confirm('Are you sure you want to delete this submitted document?')) {

        axios.post(`/reem/delete/attachments/${attachment.id}`).then(response => {
            if(attachment.type == "competent_document_certificate"){
              this.form.competent_document_certificate = null
              this.certificate_upload = false; 
            }
            if(attachment.type == "academic_document_certificate"){
              this.form.academic_document_certificate = null
              this.academic_upload = false; 
            }
            
            if(attachment.type == "lampiran_a"){
              this.form.lampiran_a = null
              this.lampiran_a_upload = false;
            }
            if(attachment.type == "resit_pembayaran"){
              this.form.resit_pembayaran = null
              this.resit_pembayaran_upload = false;
            }
            if(attachment.type == "passport_photo"){
              this.form.passport_photo = null
              this.passport_photo_upload = false;
            }
            if(attachment.type == "surat_pengesahan"){
              this.form.surat_pengesahan = null
              this.surat_pengesahan_upload = false;
            }
            if(attachment.type == "ic_copy"){
              this.form.ic_copy = null
              this.ic_copy_upload = false;
            }
       
      }).catch(error => { });

      }
    },
    postCompetent(competent){

      const formData = new FormData();
      formData.append('managers_id', this.managers_id);
      formData.append('owner_id', this.managers.user_id);
      formData.append('competent', competent.record);
      formData.append('competent_id', competent.id);
      formData.append('competent_name', competent.name);
      formData.append('competent_certificate', competent.cert_no);
      formData.append('competent_restriction', competent.competent_restriction);
      formData.append('competent_document_certificate', competent.competent_document_certificate);
      
      axios.post(`/reem/${this.managers_id}/competents`, formData).then(response => {

        
        if(competent.record == "create"){
          let item = {key: competent.id, item: response.data.competent_id};
          this.new_entries.push(item);
        }

        this.competent__ = response.data.competent; 
        this.certificate_upload=(this.competent__.competent_document_certificate.attachment)?true : false
      }).catch(error => { });
    },  
    postAcademic(academic){

      const formData = new FormData();
      formData.append('managers_id', this.managers_id);
      formData.append('owner_id', this.managers.user_id);
      formData.append('academic', academic.record);
      formData.append('academic_id', academic.id);
      formData.append('academic_name', academic.name);
      formData.append('academic_course', academic.course);
      formData.append('academic_cert_date', academic.cert_date);
      formData.append('academic_document_certificate', academic.academic_document_certificate);

      axios.post(`/reem/${this.managers_id}/academics`, formData).then(response => {
        
        if(academic.record == "create"){
          let item = {key: academic.id, item: response.data.academic_id};
          this.new_entries.push(item);
        }
        this.academic__ = response.data.competent; 
        this.academic_upload=(this.academic__.academic_document_certificate.attachment)?true : false
      }).catch(error => { }); 
    },
    postExperience(experience){
      const formData = new FormData();
      formData.append('managers_id', this.managers_id);
      formData.append('experience', experience.record);
      formData.append('experience_id', experience.id);
      formData.append('experience_name', experience.name);
      formData.append('experience_address', experience.address);
      formData.append('experience_position', experience.position);
      formData.append('experience_jobs', experience.jobs);
      formData.append('experience_start_date', experience.start_date);
      formData.append('experience_end_date', experience.end_date);
      axios.post(`/reem/${this.managers_id}/experiences`, formData).then(response => {

        if(experience.record == "create"){
          let item = {key: experience.id, item: response.data.experience_id};
          this.new_entries.push(item);
        }

      }).catch(error => { }); 
    },
    postCourse(course){

      const formData = new FormData();
      formData.append('managers_id', this.managers_id);
      formData.append('course', course.record);
      formData.append('course_id', course.id);
      formData.append('course_name', course.name);
      formData.append('course_scope', course.scope);
      formData.append('course_course', course.course);
      formData.append('course_year', course.year);
      formData.append('course_duration', course.course_duration);
      formData.append('course_organizer', course.organizer);
      formData.append('course_others', course.others);
      axios.post(`/reem/${this.managers_id}/courses`, formData).then(response => {

        if(course.record == "create"){
          let item = {key: course.id, item: response.data.course_id};
          this.new_entries.push(item);
        }

      }).catch(error => { }); 
    },
    isDeclared(status){
      let stat = false;
      if(status == 'agree')stat = true;
      return stat;      
    },
    isAcknowledged(status){
      let stat = false;
      if(status == 'acknowledge')stat = true;
      return stat;      
    },
    isPaid(status){
      let stat = false;
      if(status == 'paid')stat = true;
      return stat; 
    },
    isPhoto(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isIdentified(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isQualified(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isCompetent(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isJobs(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isExperienced(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    isEmployeer(status){
      let stat = false;
      if(status == 'attached')stat = true;
      return stat; 
    },
    removeRecord(target, item){
      if (confirm('Are you sure you want to remove this record?')) {
          
        const formData = new FormData();
          formData.append('target', target);
          formData.append('item', item);

          this.new_entries.forEach((row) => {
          if(row.key == item){
              formData.append('item', row.item);
            }  
          });

          
          axios.post(`/reem/${this.managers.id}/cancel`, formData).then(response => {
            if(target=="competents"){
              this.competents = this.competents.filter(competent => !(competent.id == item));
              this.toggleCompetentPerson()
            }
            if(target=="academics"){
              this.academics = this.academics.filter(academic => !(academic.id == item));
              this.toggleAcademics()
            }
            if(target=="experiences"){
              this.experiences = this.experiences.filter(experience => !(experience.id == item));
              this.toggleExperiences()
            }
            if(target=="courses"){
              this.courses = this.courses.filter(course => !(course.id == item));
              this.toggleCourses()
            }    
          }).catch(error => { }); 
        }
    },
    togglePay(is_paid){
      if(!is_paid){
        this.managers.has_fees = "unpaid"
      }else{
        this.managers.has_fees = "paid" 
      }
      
      this.$inertia.post(`/reem/fees/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })
    },
    togglePhoto(has_photos){

      if(!has_photos){
        this.managers.has_photos = "unattached"
      }else{
        this.managers.has_photos = "attached"     
      }
      
      this.$inertia.post(`/reem/photos/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })
    },
    toggleIdentified(has_id){
      if(!has_id){
        this.managers.has_id = "unattached"
      }else{
        this.managers.has_id = "attached"     
      }
      
      this.$inertia.post(`/reem/identifications/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })
    },
    toggleQualification(has_qualification){
      if(!has_qualification){
        this.managers.has_qualification = "unattached"
      }else{
        this.managers.has_qualification = "attached"     
      }
      
      this.$inertia.post(`/reem/qualifications/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })
    },
    toggleCompetent(has_competent){
      if(!has_competent){
        this.managers.has_competent = "unattached"
      }else{
        this.managers.has_competent = "attached"     
      }
      
      this.$inertia.post(`/reem/competence/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })
    },
    toggleJobs(has_jobs_description){
      if(!has_jobs_description){
        this.managers.has_jobs_description = "unattached"
      }else{
        this.managers.has_jobs_description = "attached"     
      }
      
      this.$inertia.post(`/reem/jobs/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })
    },
    toggleExperienced(has_jobs_experience){
      if(!has_jobs_experience){
        this.managers.has_jobs_experience = "unattached"
      }else{
        this.managers.has_jobs_experience = "attached"     
      }
      
      this.$inertia.post(`/reem/experience/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })
    },
    toggleEmployeer(has_employer_acknowledged){
      if(!has_employer_acknowledged){
        this.managers.has_employer_acknowledged = "unattached"
      }else{
        this.managers.has_employer_acknowledged = "attached"     
      }
      
      this.$inertia.post(`/reem/employeer/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })
    },
    toggleStatus(is_declared){

      if(!is_declared){
        this.managers.is_declared = "disagree"
      }else{
        this.managers.is_declared = "agree"     
      }
      
      this.$inertia.post(`/reem/status/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })

    },
    toggleAcknowledge(is_acknowledged){
      if(!is_acknowledged){
        this.managers.is_acknowledged = "deny"
      }else{
        this.managers.is_acknowledged = "acknowledge"     
      }
      
      this.$inertia.post(`/reem/acknowledge/${this.managers.id}`, {
          //onSuccess: () => reff.scrollIntoView()
      })
    },
    removeAttachment(attachment, competent){
      let target = new Object();
      if(this.competent__){
        if(attachment=='competent_document_certificate' && this.competent__.competent_document_certificate.attachment){
          target.id = this.competent__.competent_document_certificate.id
          target.type = 'competent_document_certificate'
        }
      }else{
        if(attachment=='competent_document_certificate' && competent.competent_document_certificate.attachment){
          target.id = competent.competent_document_certificate.id
          target.type = 'competent_document_certificate'
        }
      }
      this.remove(target)   
    },
    generateForm(target){
        this.form.post(`/reports/${this.managers_id}/generate/${target}/`, {
            preserveState: false,
            preserveScroll: true,
            onSuccess: () => {
              
            }
        }) 
      },
    generateCertificate(target){
        this.saveQRCode(target);
    
    },
    saveQRCode(target) {
      // Find the only <canvas> element on the page
      const canvas = document.querySelector('canvas'); // Only canvas on the page
      
      if (canvas) {
          canvas.toBlob((blob) => {

            const formData = new FormData();
            formData.append('qr_image', blob, this.managers.url_hash + '.png');
            formData.append('file_name', this.managers.url_hash + '.png');

            // Use Axios to send the data to the server
            axios.post(`/reem/${this.managers.id}/qrcode`, formData)
              .then(response => {
                  this.form.post(`/reports/${this.managers_id}/generate/${target}/`, {
                      preserveState: false,
                      preserveScroll: true,
                      onSuccess: () => {
                        
                      }
                  })                
              })
              .catch(error => {
                console.error('Error:', error);
              });
          }, 'image/png');
        } else {
          
      }
    },         
    loadAttachment(attachment, competent){

      let target = "";

      if(attachment=='competent_document_certificate'){
        target = this.competent__.competent_document_certificate.attachment;
      }

      if(attachment=='academic_document_certificate'){
        target = this.academic__.academic_document_certificate.attachment;
      }
      
      window.open(target, '_newtab');    
    },
    checkImageUrl(imageUrl, callback){
      const img = new Image();

      img.onload = function() {
        // Image loaded successfully
        callback(true);
      };

      img.onerror = function() {
        // Failed to load the image
        callback(false);
      };

      img.src = imageUrl;
    },
    urlToBlob(url) {
      return fetch(url)
        .then(response => response.blob())
        .then(blob => blob);
    },
    certExpiry(timestamp){
        return moment(timestamp).format("DD-MM-Y")
    }, 
  },
}
</script>
